import {atom} from 'jotai';
import type {PageType} from '@/_application/core/types';

export enum NavigationMenuEnum {
    HOME,
    CATEGORY,
    GIFT,
    // RING,
    ACCOUNT,
    NONE,
}

export const activeNavigationAtom = atom<NavigationMenuEnum>(NavigationMenuEnum.HOME);

export const isCategoryModelOpenAtom = atom<boolean>(false);

export const currentSelectedCategoryIndexAtom = atom<number>(0);

export const pageNameServerSideAtom = atom<string>('');

export const isHiddenNavigationAtom = atom<boolean>(false);

/**
 * Tracks the current page type for mobile layout differentiation.
 * Each App Router page sets this atom so that TopNavigationBar,
 * NavigationMobile, and ChatWidget can render the correct layout.
 */
export const currentPageTypeAtom = atom<PageType | null>(null);
